import getSlug from './getSlug'
import ApiSite from '@/classes/ApiSite'

export default function getPostLink (item, full = false) {
  if (item?.link) {
    return item.link
  }
  // Slug-based URL только для RU
  const lang = ApiSite.getLanguage()
  if (lang === 'ru') {
    const slug = item?.slug || getSlug(item?.text) || item.value
    return `${full ? '/help' : ''}/${slug}`
  }
  // Для других языков - старый формат
  return `${full ? '/help' : ''}/post/${item.value}`
}
